import React,{useState,useEffect} from 'react'
import templateService from '../../../services/template.service'
import { useNavigate, Link } from 'react-router-dom';
import TemplateListItem from './TemplateListItem';

function TemplateList({type}) {
  const [templateList,setTemplateList] = useState([])

  useEffect(()=>{
      //get template list
      getTemplateList()
  },[])

  const getTemplateList = ()=>{
    const templateType = type.toUpperCase()
    templateService.getEcxTemplate(1,templateType,0,50)
    .then(res=>{
      setTemplateList(res.data.content)
    })      
    .catch(err=>{
      console.log("Error in Template List")
      console.log(err)
    })
  }
  return (
   <div className="card">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="card-title">Eyeconx {type} templates</h5>
         
          <Link to="add" className="btn btn-primary btn-sm"><i className="bi bi-plus"></i> Add</Link>
        </div>
       
        <ul className="list-group mt-3">
          {
            templateList && templateList.map(item=>{
              //console.log(item)
              return <TemplateListItem  key={item.id} item={item} type={type}/>
            })
          }
            
            
        </ul>
       
      </div>
   </div>
  )
}

export default TemplateList